'use client';

import React from 'react';
import ContentInterpreter from '@/components/ContentInterpreter/ContentInterpreter';
import styles from './AboutPremiumContent.module.scss'; // Assuming you have a separate SCSS file for styles

interface AboutPremiumContentProps {
  content: string;
  sectionName: string;
}

const AboutPremiumContent: React.FC<AboutPremiumContentProps> = ({ content, sectionName }) => {
  return (
    <div>
      <h2 className={styles.sectionHeading}>{sectionName}</h2>
      <div className={styles.linkContainer}>
      <ContentInterpreter text={content} />
      </div>
    </div>
  );
};

export default AboutPremiumContent;
